import { Table, Form, Input, Modal, message, Spin } from "antd";
import moment from "moment";
import DataFilter from "../../common/components/DataFilter";
import DataTable, { DataTableProps, DataTableRef } from "../../common/components/DataTable";
import { Infraccion } from "../../infracciones/hooks/useInfraccionesAPI";
import { ActionResult, Model, Query } from "../../common/hooks/useApi";
import { ForwardedRef, forwardRef, useState } from "react";
import { FilterValue } from "antd/lib/table/interface";
import useLotesImpresionAPI from "../../lotes-impresion/useLotesImpresionAPI";
import styled from "styled-components";

const FullscreenSpin = styled.div`
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
display: flex;
align-items: center;
justify-content: center;
z-index: 100000;
background: rgba(255,255,255,0.5);`

export interface InfraccionesInfractorTableProps {
    list: (query: Query) => Promise<ActionResult<Infraccion[]>>
    onInfraccionesSelectionChanged?: (items: Infraccion[]) => any
    title: string
    setSelectedInfraccionesIds?: any
    sourceData?: Infraccion[]
}

const InfraccionesInfractorTable = (props: InfraccionesInfractorTableProps, ref: ForwardedRef<DataTableRef>) => {
    const loteImpresionApi = useLotesImpresionAPI();
    const [selectedPdfUrl, setSelectedPdfUrl] = useState<string>();
    const [loading, setLoading] = useState(false);
    const [idForm] = Form.useForm();
    const [selectedItems, setSelectedItems] = useState<Infraccion[]>([]);
    const [selectedInfraccionIds, setSelectedInfraccionIds] = useState<number[]>([]);
    // const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [pageSize, setPageSize] = useState(10);

    const showPdf = async (idInfraccion: number) => {
        setLoading(true)
        try {
            const response = await loteImpresionApi.getActaPdf(idInfraccion!)
            if (response.error) throw new Error(response.error)
            setSelectedPdfUrl(response.data?.value)
        }
        catch (e) {
            console.error(e)
            message.error("Error al cargar el .pdf")
        }
        setLoading(false)
    }

    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
        setSelectedRowKeys(newSelectedRowKeys);
        props?.setSelectedInfraccionesIds(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };


    return (
        <>
            {loading && <FullscreenSpin>
                <Spin size="large" />
            </FullscreenSpin>}

            <Modal
                width={"90%"}
                style={{ maxWidth: "1024px" }}
                bodyStyle={{ height: "80vh", overflow: "auto" }}
                onCancel={() => setSelectedPdfUrl(undefined)}
                open={selectedPdfUrl !== undefined} footer={null} >
                {selectedPdfUrl && <iframe style={{ width: "100%", height: "100%" }} src={selectedPdfUrl} />}
            </Modal>

            <Table<Infraccion>
                rowSelection={rowSelection}
                dataSource={props.sourceData}
                rowKey={(row) => row.Id}
                pagination={{
                    pageSize: pageSize,
                    pageSizeOptions: ['10', '20', '50', '100'],
                    showSizeChanger: true, 
                    showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} elementos`, // Texto informativo
                    onShowSizeChange: (current, size) => {
                        setPageSize(size);
                    }
                }}
            //onChange={(pagina, filtro, orden, data) => console.log(data, selectedRowKeys)}
            >
                <Table.Column<Infraccion>
                    width={`10%`}
                    title="Id"
                    dataIndex={"Id"}
                    key={'Id'}
                    defaultSortOrder={"descend"}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={idForm} >
                                <Form.Item name={"Id"} style={{ marginBottom: 10 }}>
                                    <Input placeholder='Id...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}
                />
                <Table.Column<Infraccion>
                    width={`10%`}
                    title="Dominio"
                    dataIndex={"Patente"}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}
                />
                <Table.Column<Infraccion>
                    width={`20%`}
                    title="Fecha de infracción"
                    dataIndex={"FechaHora"}
                    sorter
                    render={(val, record) => moment(record.FechaHora).format("DD/MM/YYYY HH:mm:ss")}
                    sortDirections={["ascend", "descend", "ascend"]}
                />
                <Table.Column<Infraccion>
                    width={`20%`}
                    title="Fecha de impresión"
                    dataIndex={"FechaImpresionGenerada"}
                    sorter
                    render={(val, record) => moment(record.FechaImpresionGenerada).format("DD/MM/YYYY HH:mm:ss")}
                    sortDirections={["ascend", "descend", "ascend"]}
                />
                <Table.Column<Infraccion>
                    width={`15%`}
                    title="Fecha 1er vencimiento"
                    dataIndex={"FechaVencimiento"}
                    sorter
                    render={(val, record) => moment(record.FechaVencimiento).format("DD/MM/YYYY")}
                    sortDirections={["ascend", "descend", "ascend"]}
                />
                <Table.Column<Infraccion>
                    width={`15%`}
                    title="Fecha 2do vencimiento"
                    dataIndex={"Fecha2doVencimiento"}
                    sorter
                    render={(val, record) => moment(record.Fecha2doVencimiento).format("DD/MM/YYYY")}
                    sortDirections={["ascend", "descend", "ascend"]}
                />
                <Table.Column<Infraccion>
                    width={`15%`}
                    title="Estado de pago"
                    dataIndex={"EstadoPago"}
                    sorter
                    render={(val, record) =>
                        <span style={{ color: record.EstadoPago == 'PAGADA' ? '#388e3c' : '#e53935' }}>
                            {record.EstadoPago}
                        </span>}
                    sortDirections={["ascend", "descend", "ascend"]}
                />
                <Table.Column<Infraccion>
                    //width={`15%`}
                    title='Acción'
                    key='action'
                    render={(val, record) =>
                        (<a onClick={() => showPdf(record.Id)}>Ver Acta</a>)}

                />
            </Table>
        </>
    )

}


export default forwardRef(InfraccionesInfractorTable) as
    (props: InfraccionesInfractorTableProps & { ref?: ForwardedRef<DataTableRef> })
        => ReturnType<typeof InfraccionesInfractorTable>;
